import { get, post } from 'api/client';
import config from 'config';
import {
  AcceptInvitationResponse,
  GetConnectedAccountsResponse,
  SwitchAccountResponse,
} from '../types/accountSwitcher';

export const AccountSwitcherApi = {
  getConnectedAccounts: (): Promise<GetConnectedAccountsResponse> =>
    get('/cognito/accounts', {
      baseURL: config.API_SERVICE_ENDPOINT,
    }),

  switchAccount: (accountId: number): Promise<SwitchAccountResponse> =>
    post(
      '/cognito/switch-account',
      { account_id: accountId },
      { baseURL: config.API_SERVICE_ENDPOINT },
    ),

  acceptInvitation: (accountId: number): Promise<AcceptInvitationResponse> =>
    post(
      `/cognito/invitations/${accountId}/accept`,
      {},
      { baseURL: config.API_SERVICE_ENDPOINT },
    ),

  declineInvitation: (accountId: number): Promise<void> =>
    post(
      `/cognito/invitations/${accountId}/decline`,
      {},
      { baseURL: config.API_SERVICE_ENDPOINT },
    ),
};
